import _toConsumableArray from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isArray } from 'vega-util';
import { isBinning } from '../../bin';
import { COLUMN, FACET_CHANNELS, POSITION_SCALE_CHANNELS, ROW } from '../../channel';
import { vgField } from '../../channeldef';
import * as log from '../../log';
import { hasDiscreteDomain } from '../../scale';
import { DEFAULT_SORT_OP, isSortField } from '../../sort';
import { hash as _hash } from '../../util';
import { isVgRangeStep } from '../../vega.schema';
import { HEADER_CHANNELS, HEADER_TYPES } from '../header/component';
import { assembleDomain, getFieldFromDomain } from '../scale/domain';
import { sortArrayIndexField } from './calculate';
import { DataFlowNode } from './dataflow';
/**
 * A node that helps us track what fields we are faceting by.
 */

export var FacetNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(FacetNode, _DataFlowNode);

  var _super = _createSuper(FacetNode);

  /**
   * @param model The facet model.
   * @param name The name that this facet source will have.
   * @param data The source data for this facet data.
   */
  function FacetNode(parent, model, name, data) {
    var _this;

    _classCallCheck(this, FacetNode);

    _this = _super.call(this, parent);
    _this.model = model;
    _this.name = name;
    _this.data = data;

    var _iterator = _createForOfIteratorHelper(FACET_CHANNELS),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var channel = _step.value;
        var fieldDef = model.facet[channel];

        if (fieldDef) {
          var bin = fieldDef.bin,
              sort = fieldDef.sort;
          _this[channel] = Object.assign({
            name: model.getName("".concat(channel, "_domain")),
            fields: [vgField(fieldDef)].concat(_toConsumableArray(isBinning(bin) ? [vgField(fieldDef, {
              binSuffix: 'end'
            })] : []))
          }, isSortField(sort) ? {
            sortField: sort
          } : isArray(sort) ? {
            sortIndexField: sortArrayIndexField(fieldDef, channel)
          } : {});
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _this.childModel = model.child;
    return _this;
  }

  _createClass(FacetNode, [{
    key: "hash",
    value: function hash() {
      var out = "Facet";

      var _iterator2 = _createForOfIteratorHelper(FACET_CHANNELS),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var channel = _step2.value;

          if (this[channel]) {
            out += " ".concat(channel.charAt(0), ":").concat(_hash(this[channel]));
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return out;
    }
  }, {
    key: "fields",
    get: function get() {
      var _a;

      var f = [];

      var _iterator3 = _createForOfIteratorHelper(FACET_CHANNELS),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var channel = _step3.value;

          if ((_a = this[channel]) === null || _a === void 0 ? void 0 : _a.fields) {
            f.push.apply(f, _toConsumableArray(this[channel].fields));
          }
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      return f;
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      var depFields = new Set(this.fields);

      var _iterator4 = _createForOfIteratorHelper(FACET_CHANNELS),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var channel = _step4.value;

          if (this[channel]) {
            if (this[channel].sortField) {
              depFields.add(this[channel].sortField.field);
            }

            if (this[channel].sortIndexField) {
              depFields.add(this[channel].sortIndexField);
            }
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return depFields;
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set(); // facet does not produce any new fields
    }
    /**
     * The name to reference this source is its name.
     */

  }, {
    key: "getSource",
    value: function getSource() {
      return this.name;
    }
  }, {
    key: "getChildIndependentFieldsWithStep",
    value: function getChildIndependentFieldsWithStep() {
      var childIndependentFieldsWithStep = {};

      var _iterator5 = _createForOfIteratorHelper(POSITION_SCALE_CHANNELS),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var channel = _step5.value;
          var childScaleComponent = this.childModel.component.scales[channel];

          if (childScaleComponent && !childScaleComponent.merged) {
            // independent scale
            var type = childScaleComponent.get('type');
            var range = childScaleComponent.get('range');

            if (hasDiscreteDomain(type) && isVgRangeStep(range)) {
              var domain = assembleDomain(this.childModel, channel);
              var field = getFieldFromDomain(domain);

              if (field) {
                childIndependentFieldsWithStep[channel] = field;
              } else {
                log.warn(log.message.unknownField(channel));
              }
            }
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      return childIndependentFieldsWithStep;
    }
  }, {
    key: "assembleRowColumnHeaderData",
    value: function assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep) {
      var childChannel = {
        row: 'y',
        column: 'x',
        facet: undefined
      }[channel];
      var fields = [];
      var ops = [];
      var as = [];

      if (childChannel && childIndependentFieldsWithStep && childIndependentFieldsWithStep[childChannel]) {
        if (crossedDataName) {
          // If there is a crossed data, calculate max
          fields.push("distinct_".concat(childIndependentFieldsWithStep[childChannel]));
          ops.push('max');
        } else {
          // If there is no crossed data, just calculate distinct
          fields.push(childIndependentFieldsWithStep[childChannel]);
          ops.push('distinct');
        } // Although it is technically a max, just name it distinct so it's easier to refer to it


        as.push("distinct_".concat(childIndependentFieldsWithStep[childChannel]));
      }

      var _this$channel = this[channel],
          sortField = _this$channel.sortField,
          sortIndexField = _this$channel.sortIndexField;

      if (sortField) {
        var _sortField$op = sortField.op,
            op = _sortField$op === void 0 ? DEFAULT_SORT_OP : _sortField$op,
            field = sortField.field;
        fields.push(field);
        ops.push(op);
        as.push(vgField(sortField, {
          forAs: true
        }));
      } else if (sortIndexField) {
        fields.push(sortIndexField);
        ops.push('max');
        as.push(sortIndexField);
      }

      return {
        name: this[channel].name,
        // Use data from the crossed one if it exist
        source: crossedDataName !== null && crossedDataName !== void 0 ? crossedDataName : this.data,
        transform: [Object.assign({
          type: 'aggregate',
          groupby: this[channel].fields
        }, fields.length ? {
          fields: fields,
          ops: ops,
          as: as
        } : {})]
      };
    }
  }, {
    key: "assembleFacetHeaderData",
    value: function assembleFacetHeaderData(childIndependentFieldsWithStep) {
      var _a, _b;

      var columns = this.model.layout.columns;
      var layoutHeaders = this.model.component.layoutHeaders;
      var data = [];
      var hasSharedAxis = {};

      var _iterator6 = _createForOfIteratorHelper(HEADER_CHANNELS),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var headerChannel = _step6.value;

          var _iterator7 = _createForOfIteratorHelper(HEADER_TYPES),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var headerType = _step7.value;
              var headers = (_a = layoutHeaders[headerChannel] && layoutHeaders[headerChannel][headerType]) !== null && _a !== void 0 ? _a : [];

              var _iterator8 = _createForOfIteratorHelper(headers),
                  _step8;

              try {
                for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                  var header = _step8.value;

                  if (((_b = header.axes) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                    hasSharedAxis[headerChannel] = true;
                    break;
                  }
                }
              } catch (err) {
                _iterator8.e(err);
              } finally {
                _iterator8.f();
              }
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          if (hasSharedAxis[headerChannel]) {
            var cardinality = "length(data(\"".concat(this.facet.name, "\"))");
            var stop = headerChannel === 'row' ? columns ? {
              signal: "ceil(".concat(cardinality, " / ").concat(columns, ")")
            } : 1 : columns ? {
              signal: "min(".concat(cardinality, ", ").concat(columns, ")")
            } : {
              signal: cardinality
            };
            data.push({
              name: "".concat(this.facet.name, "_").concat(headerChannel),
              transform: [{
                type: 'sequence',
                start: 0,
                stop: stop
              }]
            });
          }
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      var row = hasSharedAxis.row,
          column = hasSharedAxis.column;

      if (row || column) {
        data.unshift(this.assembleRowColumnHeaderData('facet', null, childIndependentFieldsWithStep));
      }

      return data;
    }
  }, {
    key: "assemble",
    value: function assemble() {
      var _a, _b;

      var data = [];
      var crossedDataName = null;
      var childIndependentFieldsWithStep = this.getChildIndependentFieldsWithStep();
      var column = this.column,
          row = this.row,
          facet = this.facet;

      if (column && row && (childIndependentFieldsWithStep.x || childIndependentFieldsWithStep.y)) {
        // Need to create a cross dataset to correctly calculate cardinality
        crossedDataName = "cross_".concat(this.column.name, "_").concat(this.row.name);
        var fields = [].concat((_a = childIndependentFieldsWithStep.x) !== null && _a !== void 0 ? _a : [], (_b = childIndependentFieldsWithStep.y) !== null && _b !== void 0 ? _b : []);
        var ops = fields.map(function () {
          return 'distinct';
        });
        data.push({
          name: crossedDataName,
          source: this.data,
          transform: [{
            type: 'aggregate',
            groupby: this.fields,
            fields: fields,
            ops: ops
          }]
        });
      }

      for (var _i = 0, _arr = [COLUMN, ROW]; _i < _arr.length; _i++) {
        var channel = _arr[_i];

        if (this[channel]) {
          data.push(this.assembleRowColumnHeaderData(channel, crossedDataName, childIndependentFieldsWithStep));
        }
      }

      if (facet) {
        var facetData = this.assembleFacetHeaderData(childIndependentFieldsWithStep);

        if (facetData) {
          data.push.apply(data, _toConsumableArray(facetData));
        }
      }

      return data;
    }
  }]);

  return FacetNode;
}(DataFlowNode);